/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateMatrixCareHomeHealthAdmissionResponse } from './CreateMatrixCareHomeHealthAdmissionResponse';
import {
    CreateMatrixCareHomeHealthAdmissionResponseFromJSON,
    CreateMatrixCareHomeHealthAdmissionResponseFromJSONTyped,
    CreateMatrixCareHomeHealthAdmissionResponseToJSON,
    CreateMatrixCareHomeHealthAdmissionResponseToJSONTyped,
} from './CreateMatrixCareHomeHealthAdmissionResponse';

/**
 * 
 * @export
 * @interface CreateMatrixCareHomeHealthAdmission201Response
 */
export interface CreateMatrixCareHomeHealthAdmission201Response {
    /**
     * 
     */
    data?: CreateMatrixCareHomeHealthAdmissionResponse;
}

/**
 * Check if a given object implements the CreateMatrixCareHomeHealthAdmission201Response interface.
 */
export function instanceOfCreateMatrixCareHomeHealthAdmission201Response(value: object): value is CreateMatrixCareHomeHealthAdmission201Response {
    return true;
}

export function CreateMatrixCareHomeHealthAdmission201ResponseFromJSON(json: any): CreateMatrixCareHomeHealthAdmission201Response {
    return CreateMatrixCareHomeHealthAdmission201ResponseFromJSONTyped(json, false);
}

export function CreateMatrixCareHomeHealthAdmission201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMatrixCareHomeHealthAdmission201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CreateMatrixCareHomeHealthAdmissionResponseFromJSON(json['data']),
    };
}

export function CreateMatrixCareHomeHealthAdmission201ResponseToJSON(json: any): CreateMatrixCareHomeHealthAdmission201Response {
    return CreateMatrixCareHomeHealthAdmission201ResponseToJSONTyped(json, false);
}

export function CreateMatrixCareHomeHealthAdmission201ResponseToJSONTyped(value?: CreateMatrixCareHomeHealthAdmission201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateMatrixCareHomeHealthAdmissionResponseToJSON(value['data']),
    };
}

